import { Component, Input, OnInit } from '@angular/core';
import { AddressInterface } from '../../../account/models/address.interface';
import { UpdateCheckPasswordVisibility } from '../../store/actions/check-password.actions';
import { Store } from '@ngrx/store';
import { ExtranetService } from '../../services/extranet.service';

@Component({
  selector: 'app-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.css'],
  standalone: false
})
export class AddressCardComponent implements OnInit {

  @Input()
  shippingAddress?: AddressInterface;

  @Input()
  displayButton: boolean;

  @Input()
  label?: string;
  
  @Input()
  index: number;
  
  @Input()
  billAddress: boolean;

  constructor(
      private store: Store<any>,
      private extranetService: ExtranetService
  ) {}

  ngOnInit() {
  }

  displayPasswordModal(page: string) {
    if (this.extranetService.getSupportUser()) {
      this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: true, password: null, page, object: this.shippingAddress}));
    } else {
      this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: true, isValid: null, password: null, page, object: this.shippingAddress}));
    }
  }

  getLabel() {
    if (this.label) {
      return this.label;
    } else if (this.shippingAddress && this.shippingAddress.label) {
      return this.shippingAddress.label;
    }
    return null;
  }
}
